/**
 * Viewing scope for facilitators. Admins are not assigned to a college;
 * this is session-local only (not stored on the user profile).
 */
const KEY = 'u80_admin_session'

export function getAdminSession() {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return { collegeName: '', workshopDate: '', collegeId: '' }
    const parsed = JSON.parse(raw)
    return {
      collegeName: parsed.collegeName || '',
      workshopDate: parsed.workshopDate || '',
      collegeId: parsed.collegeId || '',
    }
  } catch {
    return { collegeName: '', workshopDate: '', collegeId: '' }
  }
}

export function setAdminSession({ collegeName, workshopDate, collegeId } = {}) {
  const next = {
    collegeName: collegeName || '',
    workshopDate: workshopDate || '',
    collegeId: collegeId || '',
  }
  try {
    sessionStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    /* ignore quota / private mode */
  }
  try {
    window.dispatchEvent(new CustomEvent('u80-session-changed'))
  } catch {
    /* ignore */
  }
  return next
}
